<div #popover triggers container="body" [isOpen]="params.isOpen" [popover]="content" [popoverContext]="context" placement="bottom" (click)="show()" (onShown)="onShown()" (onHidden)="onHidden()" data-cy="DIV-969a">
  <ng-content></ng-content>
</div>
<div class="modal-backdrop fade in show" *ngIf="params.isBackgroundVisible" (click)="hide()" data-cy="DIV-5883"></div>
